<template>
  <div>
    <select
      class="form-control"
      :placeholder="placeholder"
      :disabled="disabled"
    ></select>
  </div>
</template>

<script>
import $ from "jquery";
import "./select2/select2.js";

export default {
  name: "Select2",
  data() {
    return {
      select2: null,
    };
  },
  model: {
    event: "change",
    prop: "value",
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    settings: {
      type: Object,
      default: () => {},
    },
    value: null,
  },
  watch: {
    options(val) {
      this.setOption(val);
    },
    value(val) {
      this.setValue(val);
    },
  },
  methods: {
    setOption(val = []) {
      this.select2.empty();
      this.select2.select2({
        ...this.settings,
        data: val,
      });
      this.setValue(this.value);
    },
    setValue(val) {
      if (val instanceof Array) {
        this.select2.val([...val]);
      } else {
        this.select2.val([val]);
      }
      this.select2.trigger("change");
    },
    isServices() {
      if (this.options.length == 0) {
        return false;
      }

      const matches = [];
      this.options.forEach((item) => {
        if (item.is_active != undefined) {
          matches.push(item);
        }
      });

      return matches.length > 0 ? true : false;
    },
  },
  mounted() {
    let customData = {};

    if (this.isServices()) {
      const customOptions = [];

      this.options.forEach((e) => {
        customOptions.push({
          id: e.id,
          text: `${e.text}`,
          html: `<div class="${
            e.is_active === false ? "disabled-option" : ""
          }">${e.text}<div>`,
        });
      });

      customData = {
        ...this.settings,
        data: customOptions,
        escapeMarkup: function(markup) {
          return markup;
        },
        templateResult: function(data) {
          return data.html;
        },
        templateSelection: function(data) {
          return data.text;
        },
      };
    } else {
      customData = {
        ...this.settings,
        data: this.options,
      };
    }

    this.select2 = $(this.$el)
      .find("select")
      .select2(customData)
      .on("select2:select select2:unselect", (ev) => {
        const { id, text, selected } = ev["params"]["data"];
        const selectValue = this.select2.val();
        this.$emit("change", selectValue);
        this.$emit("select", { id, text, selected });
      });
    this.setValue(this.value);
  },
  beforeDestroy() {
    setTimeout(() => {
      this.select2.select2("destroy");
    }, 500);
  },
};
</script>

<style scope>
@import "./select2/select2.min.css";
.not-active {
  background-color: pink;
}
</style>

<style>
/* .disabled-option {
    background-color:  #d9d8d8;
    height: 30px;
    width: 110%;
    margin-top: -10px;
    margin-left: -10px;
    padding-left: 10px;
    margin-bottom: -10px;
    padding-top: 7px;
    color: #000 !important;
 }

.disabled-option:hover {
  color: #000 !important;
} 

.select2-container--default .select2-results__option[aria-selected=true] {
    background-color: #fff !important;
} */
</style>
